import { Download } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export const ExportJsonButton = ({ player, compact = false, testId }) => {
  const download = async () => {
    try {
      const r = await api.get(`/admin/players/${player.id}/export`, { responseType: "blob" });
      const name = /filename="([^"]+)"/.exec(r.headers["content-disposition"] || "")?.[1] || `${player.id}.json`;
      const url = URL.createObjectURL(r.data);
      const a = Object.assign(document.createElement("a"), { href: url, download: name });
      a.click();
      URL.revokeObjectURL(url);
      toast.success(`Downloading ${name}`);
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  return compact ? (
    <button data-testid={testId} onClick={download} title="Export JSON" className="rounded-md p-2 text-slate-400 hover:bg-slate-800 hover:text-white">
      <Download className="h-4 w-4" />
    </button>
  ) : (
    <button data-testid={testId} onClick={download}
      className="inline-flex items-center gap-2 rounded-full border border-slate-700 px-4 py-2 text-sm transition-colors hover:border-[#FF2D78]">
      <Download className="h-4 w-4" /> Export JSON
    </button>
  );
};
